import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  // debounce,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { Fragment, useContext, useEffect, useMemo, useState } from "react";
import {
  BodySystemListType,
  PhysicalExaminationParams,
  RosType,
  SelectedFieldType,
} from "./types";
import { useMutation } from "react-query";
import {
  getBodySystemList,
  // getRosBs,
  getRosFieldData,
  postSecontPhySicalExamination,
  removePhysicalExamination,
} from "../../services";
import usePopup from "../../../hooks/usePopup";
import ErrorIcon from "@mui/icons-material/Error";
import { getItem, setItem } from "../../../utilis/methods/storage/storage";
import { useParams } from "react-router-dom";
import PhysicalExaminationAutocomplete from "./PhyscicalExaminationAutocomplete";
import { clinicId, userType } from "../../../constants";
import LogComonent from "../layouts/LogComonent";
import { PhysicalExaminationContext } from ".";
import useAuthentication from "@hooks/useAuthentication";
import { EmrContext } from "../../index";
const storedField = "storedField";
function PhysicalExaminationRos() {
  const { control, handleSubmit, reset } = useForm();
  const { refetchRos, setRefetchRos } = useContext(PhysicalExaminationContext);
  const { encounterId } = useParams();
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const { triggerConsultationStart } = useContext(EmrContext);
  const theme = useTheme();
  const [selected, setSelected] = useState({});
  const [fields, setFields] = useState<BodySystemListType[]>([]);
  const fieldToRender = useMemo(() => {
    const fieldArray: SelectedFieldType = fields;
    return fieldArray || [];
  }, [fields]);

  const handleSetRosFieldData = (data: any) => {
    let fieldData = {};
    const updated: { [key: string]: BodySystemListType } = {}
    for (let key in data) {
      if (data[key].ros.length > 0) {
        fieldData = {
          ...fieldData,
          [key]: data[key].ros,
          [`${key}Remarks`]: data[key].remarks,
          [`${key}Status`]: data[key].severity,
        };
        const validField = fields.find((item) => item.bodySystemName == key);
        updated[key as keyof typeof updated] = validField as BodySystemListType
        handleSelectOnApiCall(validField as BodySystemListType);
        setSelected(updated)
      }
    }
    if (Object.entries(fieldData).length) {
      reset({ ...fieldData });
    }
  };;

  const { mutate: fetchPhysicalExamination, data: fetchedRosList } =
    useMutation(getRosFieldData, {
      onSuccess: (result) => {
        if (result.responseIndicator == "success" && result.response) {
          // handleSetRosFieldData(result.response);
          console.log("result.response => ", result.response);
          setRefetchRos(false);
        }
      },
    });

  const { mutate: savePhysicalExamination, isLoading } = useMutation(
    postSecontPhySicalExamination,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          showSnackbar({
            message: "Saved successfully",
            open: true,
            variant: "success",
          });
          fetchPhysicalExamination(encounterId as string);
        } else {
          showSnackbar({
            message: "failed !",
            open: true,
            variant: "warning",
          });
        }
      },
      onError: () => {
        showSnackbar({
          message: "Something went wrong",
          open: true,
          variant: "warning",
        });
      },
    },
  );

  const { mutate: deleteRos } = useMutation(removePhysicalExamination, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: "Removed successfully",
          open: true,
          variant: "success",
        });
        setRefetchRos(true);
      } else {
        showSnackbar({
          message: "Somthing went wrong",
          open: true,
          variant: "warning",
        });
      }
    },
  });

  const { mutate: fetchBodySystemList } = useMutation(getBodySystemList, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setFields(result.response);
      } else {
        setFields([]);
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.message ||
          "Error fetching body system list !",
        open: true,
        variant: "error",
        duration: 3000,
      });
      setFields([]);
    },
  });

  const handleSelect = (item: BodySystemListType) => {
    let updated: { [key: string]: BodySystemListType } = {};
    if (item.bodySystemId != 0) {
      updated = { ...selected };
      updated["All"] && delete updated["All"];
      if (Boolean(updated[item.bodySystemName as keyof typeof updated])) {
        delete updated[item.bodySystemName as keyof typeof updated];
      } else {
        updated = { ...selected, [item.bodySystemName]: item };
      }
    } else {
      if (!selected[item.bodySystemName as keyof typeof selected]) {
        fields.forEach((i) => {
          updated = {
            ...updated,
            [i.bodySystemName as keyof typeof updated]: i,
          };
        });
        updated[item.bodySystemName as keyof typeof updated] = item;
      } else {
        updated = {};
      }
    }
    setItem(storedField, updated);
    setSelected(updated);
  };

  const handleSelectOnApiCall = (item: BodySystemListType) => {
    let updated = { ...selected };
    updated = { ...selected, [item.bodySystemName]: item };
    setSelected(updated);
  };

  const handleSetParams = (
    ros: RosType[],
    remarks: string,
    severity: string,
    bodySystemId: number,
    isModified: 0 | 1,
  ) => {
    let formatingArray: PhysicalExaminationParams[] = [];
    ros.forEach((item) => {
      formatingArray = [
        ...formatingArray,
        {
          physicalExamId: item.physicalExamId || null,
          clinicID: clinicId,
          createdById: Number(user?.userId),
          encounterID: parseInt(encounterId as string),
          ip: "",
          isModified,
          remarkId: null,
          remarks: remarks != "null" && Boolean(remarks) ? remarks : "",
          revertFlag: false,
          rosId: item.rosId || 0,
          severity: severity != "null" && Boolean(severity) ? severity : "",
          status: 1,
          userType: userType,
          bodySystemId: bodySystemId,
          ...(item.rosId == 0 || item.rosId == null || item.rosId == undefined
            ? { rosManual: item.rosName }
            : {}),
        },
      ];
    });
    console.log("formatingArray ==>>", formatingArray);
    return formatingArray;
  };

  const handledeleteChip = (
    { prev, current }: { prev: RosType[]; current: RosType[] },
    key: keyof typeof selected,
  ) => {
    if (prev?.length > current?.length) {
      const deleted = prev.find(
        (p) =>
          !Boolean(current.find((c) => p.physicalExamId == c.physicalExamId)),
      );
      const previouslyAdded = fetchedRosList?.response[key]?.ros;
      const isIncluded =
        previouslyAdded?.find((item: any) => item.rosId == deleted?.rosId) ||
        false;
      if (deleted && previouslyAdded?.length && isIncluded) {
        deleteRos(deleted?.physicalExamId);
      }
    }
  };

  const onSubmit = (value: any) => {
    let saveParams: PhysicalExaminationParams[] = [];
    console.log("value ==> ", value);
    for (let key in selected) {
      value[key];
      if (value[key]?.length) {
        saveParams = [
          ...saveParams,
          ...handleSetParams(
            value[`${key}`],
            value[`${key}Remarks`],
            value[`${key}Status`],
            value[`${key}BodyId`],
            0,
          ),
        ];
      }
    }
    if (saveParams.length) {
      triggerConsultationStart();
      savePhysicalExamination(saveParams);
    } else {
      showSnackbar({
        message: "No ROS added !",
        open: true,
        variant: "warning",
      });
    }
  };

  useEffect(() => {
    const storedFields = getItem(storedField);
    if (Boolean(storedFields)) {
      setSelected(storedFields);
    }
    fetchBodySystemList();
  }, []);

  useEffect(() => {
    if (refetchRos) {
      fetchPhysicalExamination(encounterId as string);
    }
  }, [refetchRos]);

  useEffect(() => {
    const filledArray = Object.values(fetchedRosList?.response || {});
    if (fields.length && filledArray.length) {
      handleSetRosFieldData(fetchedRosList?.response);
    }
  }, [fields, fetchedRosList]);

  return (
    <div className="border-2 rounded">
      <div className="grid grid-cols-10 p-1 border-b  rounded-t">
        <div className="col-span-6">
          <Typography color={theme.palette.primary.main} fontWeight={600}>
            Physical Examinations Ros
          </Typography>
        </div>
        <div className="col-span-4 flex flex-row justify-end items-center gap-3">
          {/* <LogComonent title="Physical examination" field="" /> */}
          <Autocomplete
            sx={{ width: "65%" }}
            value={null}
            options={
              fields
                ? [{ bodySystemId: 0, bodySystemName: "All" }, ...fields]
                : []
            }

            getOptionLabel={(option) => option.bodySystemName}
            renderInput={(field) => (
              <TextField {...field} placeholder="Add fields" />
            )}
            renderOption={(_, option) => (
              <Fragment key={`dropdown${option.bodySystemId}`}>
                <ListItemButton
                  onClick={() => {
                    handleSelect(option);
                  }}
                  sx={{ paddingx: 1 }}
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={Boolean(
                        selected[
                        option.bodySystemName as keyof typeof selected
                        ],
                      )}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{
                        "aria-labelledby": `checkbox-list-label-${option.bodySystemName}`,
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={`checkbox-list-label-${option.bodySystemName}`}
                    primary={option.bodySystemName}
                  />
                </ListItemButton>
              </Fragment>
            )}
          />
          <LogComonent field="ros" title="Physical examination" />
        </div>
      </div>
      <Collapse in={true}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="p-2 grid grid-cols-12 gap-2"
        >
          {fields?.map((item, index) =>
            item?.bodySystemId != 0 && selected[item.bodySystemName as keyof typeof selected] ? (
              <Fragment key={`fieldId${index}`}>
                <div className="col-span-6">
                  <PhysicalExaminationAutocomplete
                    element="autocomplete"
                    control={control}
                    options={[]}
                    id={item?.bodySystemId}
                    name={`${item?.bodySystemName}`}
                    rules={{ required: false }}
                    handleOperation={(param) => {
                      handledeleteChip(param, item?.bodySystemName as never);
                    }}
                    fieldProps={{
                      label: item?.bodySystemName,
                    }}
                    autocompleteProps={{
                      multiple: true,
                      filterOptions: (option) => option,
                      getOptionLabel: (option) => option.rosName,
                      isOptionEqualToValue: (option, value) =>
                        option.rosName == value.rosName,

                      renderTags: (value: any[], getTagProps: any) =>
                        value.map((option, index) => (
                          <Tooltip
                            key={index}
                            title={option.rosName}
                            arrow
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  maxWidth: 500,
                                }
                              }
                            }}
                          >
                            <Chip {...getTagProps({ index })} label={option.rosName} />
                          </Tooltip>
                        )),
                    }}
                  />
                </div>
                <div className="col-span-3">
                  <CustomFormField
                    name={`${item?.bodySystemName}Remarks`}
                    control={control}
                    element="input"
                    rules={{ required: false }}
                    fieldProps={{ label: "Remarks", multiline: true }}
                  />
                </div>
                <div className="col-span-3">
                  <CustomFormField
                    name={`${item?.bodySystemName}Status`}
                    options={status}
                    control={control}
                    element="autocomplete"
                    rules={{ required: false }}
                    fieldProps={{ label: "Severity" }}
                    autocompleteProps={{
                      isOptionEqualToValue: (option, value) => option == value,
                      getOptionLabel: (option) => option,
                    }}
                  />
                </div>
                <div className="hidden">
                  <Controller
                    name={`${item?.bodySystemName}BodyId`}
                    control={control}
                    defaultValue={item.bodySystemId}
                    render={({ field }) => <TextField {...field} />}
                  />
                </div>
                <div className="col-span-full py-2">
                  <Divider />
                </div>
              </Fragment>
            ) : null,
          )}

          <div className="flex justify-end items-end gap-3 col-span-full">
            {fieldToRender.length > 0 ? (
              <Button
                type="submit"
                color="success"
                disabled={isLoading}
                endIcon={
                  isLoading && (
                    <CircularProgress
                      size={18}
                      sx={{ color: theme.palette.background.paper }}
                    />
                  )
                }
              >
                save
              </Button>
            ) : (
              <div className="flex w-full justify-center">
                <Typography>
                  Add some fields <ErrorIcon color="primary" />
                </Typography>
              </div>
            )}
          </div>
        </form>
      </Collapse>
    </div>
  );
}

export default PhysicalExaminationRos;

const status = ["Low", "Medium", "High"];
